import { render, staticRenderFns } from "./ManagerNotificationsToAccept.vue?vue&type=template&id=7d226e31&scoped=true"
import script from "./ManagerNotificationsToAccept.vue?vue&type=script&lang=js"
export * from "./ManagerNotificationsToAccept.vue?vue&type=script&lang=js"
import style0 from "./ManagerNotificationsToAccept.vue?vue&type=style&index=0&id=7d226e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d226e31",
  null
  
)

export default component.exports